import axios from "axios";
// import { ValidationError } from '@/errors/Validation-Error';
import { i18n } from "@/i18n";
axios.defaults.baseURL = process.env.VUE_APP_BASE_URL + process.env.VUE_APP_API;
export class Request {
  constructor(method, endpoint, data, token, params, headers) {
    this.method = method;
    this.endpoint = endpoint;
    this.data = data;
    this.token = localStorage.getItem("dmtoken");
    this.params = params;
    this.headers = headers;
  }

  async send() {
    try {
      let response = await axios({
        method: this.method,
        url: this.endpoint,
        data: this.data,

        headers: {
          Authorization: `Bearer ${this.token}`,
          "Content-Type": this.headers
            ? "application/json"
            : "multipart/form-data",
        },
        params: this.params,
      });

      return response.data;
    } catch (error) {
      if (error.toJSON().message === "Network Error") {
        // throw new ValidationError('Internet Error', "INTERNET ERROR");
        throw i18n.t(`toastAlert.ERR_NETWORK`);
      } else if (error.response.data.status === "fail") {
        // throw new ValidationError("USER ERROR", this.errorMapper(error.response.data.error));
        const type = error.response.data.error
          ? `toastAlert.${error.response.data.error}`
          : `toastAlert.VALIDATION_ERROR`;
        throw i18n.t(type);
      }
    }
  }
  errorMapper(type) {
    const error = new Map([
      ["PASSWORD_INVALID", "invalid_password"],
      ["EMAIL_ALREADY_EXISTS", "email_already_exists"],
      ["USERNAME_ALREADY_EXISTS", "The User Name is  Used Already"],
      ["VERIFY_TOKEN_INVALID", "Invalid Verify Code"],
      ["RESET_CODE_INVALID", "Invalid Reset Code"],
      ["RESOURCE_NOT_FOUND", "Error in Email"],
      ["NOT_VERIFIED", "Verify Please"],
      ["UNACCEPTABLE_OPERATION", "Error in Verify Code"],
      ["RESOURCE_ALREADY_EXISTS", "Email already Exist"],
      ["The reset code is not valid", "The reset code is not valid"],
      ["ERR_NETWORK", "Internet Error"],
      ["ERR_TIMED_OUT", "Internet Error"],
      ["ERR_INTERNET_DISCONNECTED", "Internet Error"],
      ["VALIDATION_ERROR", "Some values is required"],
      ["INVALID_CREDENTIALS", "Email or password is incorrect"],
      ["RELATED_RESOURCE_EXISTED", "There is a related resource"],
    ]);
    return error.get(type);
  }
}
